import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import goatFrame from "../../../assets/icons/goatAvaterImage.png";
import clownFrame from "../../../assets/icons/clown-icon.png";
import vipIcon from "../../../assets/images/vip-icon.png";
import {
  getAvatarFrameType,
  getClownGifts,
  getGoatGifts,
} from "../../avatarFrame";
import "./ChatUserAvatar.scss";

const DEFAULT_CHAT_AVATAR =
  "https://fapi.fanzaty.net/api/v1/avtar/get-image/boy3.svg";

const ChatUserAvatar = ({
  user,
  fallback,
  size = "sm",
  to,
  className = "",
  imgClassName = "",
  alt = "avatar",
}) => {
  const { t } = useTranslation("common");
  const avatarBadge = getAvatarFrameType(user);
  const goatCount = getGoatGifts(user);
  const clownCount = getClownGifts(user);
  const avatarSrc =
    (user?.avatarUrl && user.avatarUrl !== "null" && user.avatarUrl) ||
    (user?.profile_pic && user.profile_pic !== "null" && user.profile_pic) ||
    fallback ||
    DEFAULT_CHAT_AVATAR;

  const content = (
    <span
      className={[
        "chat-framed-avatar",
        `chat-framed-avatar--${size}`,
        avatarBadge ? `has-${avatarBadge}` : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <img
        src={avatarSrc}
        alt={alt}
        className={`chat-framed-avatar__img${imgClassName ? ` ${imgClassName}` : ""}`}
        loading="lazy"
      />
      {avatarBadge === "goat" && (
        <>
          <img
            src={goatFrame}
            alt=""
            className="chat-framed-avatar__frame chat-framed-avatar__frame--goat"
            draggable={false}
          />
          <Tooltip title={t("user_profile.goat_gifts")}>
            <span className="chat-framed-avatar__count chat-framed-avatar__count--goat">
              {goatCount}
            </span>
          </Tooltip>
        </>
      )}
      {avatarBadge === "clown" && (
        <>
          <img
            src={clownFrame}
            alt=""
            className="chat-framed-avatar__frame chat-framed-avatar__frame--clown"
            draggable={false}
          />
          <Tooltip title={t("user_profile.clown_gifts", "Clown Gifts")}>
            <span className="chat-framed-avatar__count chat-framed-avatar__count--clown">
              {clownCount}
            </span>
          </Tooltip>
        </>
      )}
      {avatarBadge === "vip" && (
        <Tooltip title={t("vip.header_label", "VIP")}>
          <img
            src={vipIcon}
            alt=""
            className="chat-framed-avatar__vip"
            draggable={false}
          />
        </Tooltip>
      )}
    </span>
  );

  if (!to) return content;

  return (
    <Link to={to} className="chat-framed-avatar-link">
      {content}
    </Link>
  );
};

ChatUserAvatar.propTypes = {
  user: PropTypes.object,
  fallback: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  to: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  alt: PropTypes.string,
};

export default ChatUserAvatar;
